import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import authorsTableData from "layouts/Meeting-management/data";
import { useEffect, useState, useRef } from "react";
import Notification from "examples/Notifications";
import { TextField } from "@mui/material";
import meetingServices from "services/meeting-services";
import { AddButton } from "layouts/common/buttons";

const MeetingManagement = () => {
    const [meetings, setMeetings] = useState([]);
    const [notification, setNotification] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedMeetings, setSelectedMeetings] = useState([]);

    useEffect(() => {
        getMeetings();
    }, []);
    const handleDelete = async (id) => {
        const response = await meetingServices.delete(id);
        if (response.success) {
            setNotification({
                type: "success",
                message: "Meeting deleted successfully.",
            });
            getMeetings();
        } else {
            setNotification({
                type: "error",
                message: "Failed to delete meeting.",
            });
        }
    };


    const getMeetings = async () => {
        const meetingData = await meetingServices.getAll();
        if (meetingData.success && meetingData.meetings) {
            const formattedMeetings = meetingData.meetings.map(meeting => ({
                ...meeting,
                date: meeting.date ? new Date(meeting.date).toLocaleDateString("en-CA") : ""
            }));
            setMeetings(formattedMeetings);
        }
    };


    useEffect(() => {
        if (searchQuery) {
            const filtered = meetings.filter((meeting) =>
                meeting.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                meeting.venue.toLowerCase().includes(searchQuery.toLowerCase()) ||
                meeting.createdBy?.name.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setSelectedMeetings(filtered);
        } else {
            setSelectedMeetings(meetings);
        }
    }, [searchQuery, meetings]);


    const { columns, rows } = authorsTableData(selectedMeetings, handleDelete, setNotification);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info"
                                display="flex" justifyContent="space-between" alignItems="center">
                                <MDTypography variant="h6" color="white"> Meetings </MDTypography>
                                <MDBox display="flex" alignItems="center" justifyContent="space-between" >
                                    <AddButton link="/meeting/create" />
                                </MDBox>
                            </MDBox>
                            <MDBox mt={3} display="block" alignItems="center" p={2}>
                                <TextField
                                    label="Search"
                                    variant="outlined"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    fullWidth
                                    sx={{ maxWidth: 300 }}
                                />
                            </MDBox>
                            <Notification notification={notification} setNotification={setNotification} />
                            <MDBox pt={3}>
                                <DataTable table={{ columns, rows }} isSorted={true} entriesPerPage={false} showTotalEntries={false} noEndBorder />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default MeetingManagement;

